//register chartjs
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
